import React, { Component } from 'react';
import { Table, Space, Modal, PageHeader } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/products';
import { ExclamationCircleOutlined, EditOutlined,DeleteOutlined } from '@ant-design/icons';

class ProductList extends Component {
    deleteProduct = (id) => {
        this.props.onDelete(id, this.props.token);
        setTimeout(() => this.props.onClear(), 500);
    }
    deleteClick = (id) => {
        Modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: 'Are you sure to delete?',
            onOk: () => { this.deleteProduct(id) },
            okText: 'Delete',
            cancelText: 'Cancel',
        });
    }
    editClick = (record) => {
        this.props.onEdit({
            id: record.id,
            name: record.name,
        });
    }
    render() {
        const dataSource = [];
        this.props.products.map(
            data => {
                let item = {};
                item.key = data.id;
                item.id = data.id;
                item.name = data.name;
                dataSource.push(item);
            }
        );

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                align:'center',
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                align:'center',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                align:'center',
                render: (text, record) => (
                    <Space size="middle">
                        <a onClick={() => { this.editClick(record) }}><EditOutlined /> Edit</a>
                        <a onClick={() => { this.deleteClick(record.id) }} style={{ color: "red" }}><DeleteOutlined /> Delete</a>
                    </Space>
                ),
            },
        ];
        return (
            <>
                <PageHeader
                    className="site-page-header"
                    title="Products"
                />
                <Table dataSource={dataSource} columns={columns} />
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        error: state.products.error,
        loading: state.products.loading,
        products: state.products.products
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onEdit: (product) => dispatch(actions.openProductEditForm(product)),
        onDelete: (id, token) => dispatch(actions.deleteProduct(id, token)),
        onClear: () => dispatch(actions.clearProductEdit()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductList);